import { render, staticRenderFns } from "./sendExams.view.vue?vue&type=template&id=56d7207c&scoped=true"
import script from "./sendExams.view.vue?vue&type=script&lang=js"
export * from "./sendExams.view.vue?vue&type=script&lang=js"
import style0 from "./sendExams.view.vue?vue&type=style&index=0&id=56d7207c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7207c",
  null
  
)

export default component.exports